module.exports = __webpack_public_path__ + "static/img/8.ac0e87f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shlzy/8.png
// module id = uqRK
// module chunks = 0